const mutations = {
    setCreditNoteList(state, data) {
        state.creditNoteList = data;
    },
}

export default mutations;